import { motion } from "framer-motion";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { resolveCtaUrl } from "../../lib/cta";

export default function Guarantee({ data, content }) {
  const ctaHref = resolveCtaUrl(content);

  return (
    <section data-testid="guarantee-section" className="py-24 lg:py-32 bg-onyx text-alabaster">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full border-2 border-gold mb-8">
            <ShieldCheck size={32} className="text-gold" strokeWidth={1.5} />
          </div>
          <p className="overline mb-4 text-gold" data-testid="guarantee-overline">{data.overline}</p>
          <h2
            data-testid="guarantee-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-tight"
          >
            {data.title}
          </h2>
          <p
            data-testid="guarantee-description"
            className="mt-6 text-lg text-alabaster/80 max-w-2xl mx-auto leading-relaxed"
          >
            {data.description}
          </p>
          <div className="mt-10 flex justify-center">
            <a
              href={ctaHref}
              target="_blank"
              rel="noreferrer"
              data-testid="guarantee-cta"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-gold text-onyx text-xs tracking-[0.25em] uppercase font-semibold hover:bg-alabaster transition-colors"
            >
              {data.ctaLabel || "Quero Começar Sem Risco"}
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
